import { navigate } from "gatsby"
import React, { Component } from "react"
import langs from "./languages.json"
import LocalsMenu from "./localsMenu.json"
import i18n, { getLocationWithoutLang } from "../utils/i18n"
import constants from "../constants"
import { gsap } from "gsap"

class LanguagesButton extends Component {
  constructor(props) {
    super(props)
    this.parent = React.createRef()
    this.pagepath = undefined
    this.state = {
      lang: undefined
    }
  }
  componentDidMount() {
    this.pagepath = getLocationWithoutLang()
  }
  componentDidUpdate() {
    this.pagepath = getLocationWithoutLang()
    if (this.props.lang !== this.state.lang) this.setState({ lang: this.props.lang })
    if (this.props.state === `open`) {
      gsap.to(this.parent.current, { autoAlpha: 1, duration: 0.6, ease: `expo.out` })
    } else {
      gsap.to(this.parent.current, { autoAlpha: 0, duration: 0.6, ease: `expo.out` })
    }
  }
  onChangeLanguage = (targetLang) => {
    navigate(`/${targetLang}/${this.pagepath}/`)
  }
  render() {
    const languageText = i18n(LocalsMenu, `title-language`, this.state.lang)
    return (
      <div ref={this.parent} style={{ visibility: `hidden` }} className={`${this.props.className} lg:rounded-full lg:inline-flex lg:items-center lg:justify-center lg:px-8 h-auto lg:h-16 ${constants.attribution}`}>
        <div className={`hidden md:inline`}>{languageText}:&nbsp;</div>
        <div className={`block whitespace-nowrap`}>
          { langs.map((item, index) => (
            <div className={`inline`} key={`${index}-lang`}>
              {index !== 0 ? `/` : ``}
              <button style={{ outline: 0 }} onClick={() => this.onChangeLanguage(item)} className={`${this.state.lang === item ? `border-black` : `border-transparent`} border-b-2 uppercase mx-1 `}>{item.toUpperCase()}</button>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default LanguagesButton
